import { jsxs as r, jsx as C } from "react/jsx-runtime";
function o() {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "12",
      height: "13",
      viewBox: "0 0 12 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.33333 1.66671V0.333374H8V1.66671H4V0.333374H2.66667V1.66671H0V3.00004H2.66667V4.33337H4V3.00004H8V4.33337H9.33333V3.00004H10.6667V11.6667H1.33333V4.00004H0V13H12V1.66671H9.33333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M3.33333 7.16671C3.79357 7.16671 4.16667 6.79361 4.16667 6.33337C4.16667 5.87314 3.79357 5.50004 3.33333 5.50004C2.8731 5.50004 2.5 5.87314 2.5 6.33337C2.5 6.79361 2.8731 7.16671 3.33333 7.16671Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.83333 6.33337C6.83333 6.79361 6.46024 7.16671 6 7.16671C5.53976 7.16671 5.16667 6.79361 5.16667 6.33337C5.16667 5.87314 5.53976 5.50004 6 5.50004C6.46024 5.50004 6.83333 5.87314 6.83333 6.33337Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.66667 7.16671C9.1269 7.16671 9.5 6.79361 9.5 6.33337C9.5 5.87314 9.1269 5.50004 8.66667 5.50004C8.20643 5.50004 7.83333 5.87314 7.83333 6.33337C7.83333 6.79361 8.20643 7.16671 8.66667 7.16671Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M4.16667 9.66671C4.16667 10.1269 3.79357 10.5 3.33333 10.5C2.8731 10.5 2.5 10.1269 2.5 9.66671C2.5 9.20647 2.8731 8.83337 3.33333 8.83337C3.79357 8.83337 4.16667 9.20647 4.16667 9.66671Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6 10.5C6.46024 10.5 6.83333 10.1269 6.83333 9.66671C6.83333 9.20647 6.46024 8.83337 6 8.83337C5.53976 8.83337 5.16667 9.20647 5.16667 9.66671C5.16667 10.1269 5.53976 10.5 6 10.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.5 9.66671C9.5 10.1269 9.1269 10.5 8.66667 10.5C8.20643 10.5 7.83333 10.1269 7.83333 9.66671C7.83333 9.20647 8.20643 8.83337 8.66667 8.83337C9.1269 8.83337 9.5 9.20647 9.5 9.66671Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  o as CalendarIcon
};
